import type { UserTheme } from '@/modules/settings';

import { DEFAULT_THEME_DATA } from '../../contants/common';
import { DEFAULT_STORE_OBJECT } from '../constants';
import type { DefaultStoreObject } from '../types';
import SettingsTypes from './SettingsTypes';

// biome-ignore lint/suspicious/noExplicitAny: TODO: remove
export interface SettingsState extends Record<string, any> {
  userThemes: DefaultStoreObject<UserTheme>;
}

const initialState = {
  userThemes: {
    ...DEFAULT_STORE_OBJECT,
    data: DEFAULT_THEME_DATA,
  },
};

// biome-ignore lint/suspicious/noExplicitAny: TODO: remove
const SettingsReducer = (state = initialState, { type, payload }: any) => {
  switch (type) {
    case SettingsTypes.SET_USER_THEMES: {
      return {
        ...state,
        userThemes: {
          ...DEFAULT_STORE_OBJECT,
          ...payload,
        },
      };
    }

    default:
      return state;
  }
};

// biome-ignore lint/style/noDefaultExport: TODO: fix
export default SettingsReducer;
